import axios from 'axios';

class BlockService {
    getList() {
        return axios.post(`${process.env.REACT_APP_API}/getBlockList`);
    }

}

export default BlockService;